/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Shop functions
window.shop = window.shop || {};

const getTransformXValue = (elem) => {
  const transformMatrix = elem.css('transform');
  const matrix = transformMatrix.replace(/[^0-9\-.,]/g, '').split(',');
  const x = matrix[4] || 0; // translate x

  return parseInt(x, 10);
}

shop.cacheSelectors = function () {
  shop.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileNavDrawer         : $('#NavDrawer'),
    $mobileNavDrawerContent  : $('#NavDrawer .drawer__content'),
    $mobileSubNavOpen        : $('.mobile-nav__sublist-open'),
    $mobileSubNavClose       : $('.mobile-nav__sublist-close'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm')
  };
};

shop.init = function () {
  shop.cacheSelectors();
  shop.accessibleNav();
  shop.drawersInit();
  shop.mobileNav();
  shop.productImageSwitch();
  shop.responsiveVideos();
  shop.loginForms();
};

shop.accessibleNav = function () {
  var $nav = shop.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.primary-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.primary-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.primary-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.primary-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      shop.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    shop.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

shop.drawersInit = function () {
  shop.LeftDrawer = new shop.Drawers('NavDrawer', 'left');
};

shop.mobileNav = function () {
  const visibleClass = 'mobile-nav__sublist--visible';
  const scrollClass = 'mobile-nav__sublist--scroll';

  shop.cache.$mobileSubNavOpen.on('click', function() {
    const currentContentX = getTransformXValue(shop.cache.$mobileNavDrawerContent);

    if (!shop.cache.$mobileNavDrawer.hasClass('sublist--visible')) {
      shop.cache.$mobileNavDrawer.addClass('sublist--visible');
    }

    $(this).next().addClass(visibleClass);
    $(`.${visibleClass}`).removeClass(scrollClass).last().addClass(scrollClass);
    $('.drawer__subcategory-title').text($(this).text());
    shop.cache.$mobileNavDrawerContent.css('transform', `translateX(${currentContentX - shop.cache.$mobileNavDrawerContent.width()}px)`);
  });

  shop.cache.$mobileSubNavClose.on('click', function() {
    const currentContentX = getTransformXValue(shop.cache.$mobileNavDrawerContent);
    const visibleSublists = $(`.${visibleClass}`);

    if (currentContentX === -shop.cache.$mobileNavDrawerContent.width()) {
      shop.cache.$mobileNavDrawer.removeClass('sublist--visible');
    } else {
      $('.drawer__subcategory-title').text(visibleSublists.first().prev().text());
    }

    visibleSublists.last().removeClass(visibleClass);
    shop.cache.$mobileNavDrawerContent.css('transform', `translateX(${currentContentX + shop.cache.$mobileNavDrawerContent.width()}px)`);
  });
};

shop.getHash = function () {
  return window.location.hash;
};

shop.productImageSwitch = function () {
  if (shop.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    shop.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      shop.switchImage(newImage, null, shop.cache.$productImage);
    });
  }
};

shop.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

shop.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

shop.loginForms = function() {
  function showRecoverPasswordForm() {
    shop.cache.$recoverPasswordForm.show();
    shop.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    shop.cache.$recoverPasswordForm.hide();
    shop.cache.$customerLoginForm.show();
  }

  shop.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  shop.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (shop.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

/*============================================================================
  Drawer modules
==============================================================================*/
shop.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    shop.cache.$body.trigger('beforeDrawerOpen.shop', this);

    // transition for close animation
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Notify the drawer has opened
    shop.cache.$body.trigger('afterDrawerOpen.shop', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    shop.cache.$body.trigger('beforeDrawerClose.shop', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    shop.cache.$body.trigger('afterDrawerClose.shop', this);

    // Reset expanded mobile nav sublist
    $('.mobile-nav__sublist').removeClass('mobile-nav__sublist--visible');
    
    // Delay resetting mobile nav until after close transition
    setTimeout(function() {
      shop.cache.$mobileNavDrawer.removeClass('sublist--visible');
      shop.cache.$mobileNavDrawerContent.css('transform', 'translateX(0)');
   }, 195);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Shop JS on docready
$(shop.init);
